import Cookies from "universal-cookie";
import env from "../env";
import ReactDOM from "react-dom/client";
import { useState } from "react";
import ShowError from "../components/Modal/ShowError";
let errorRoot = null;

const PostReq = async (props) => {
  const cookies = new Cookies();
  const errorElement = document.getElementById("error");
  const method = props.method ? props.method : "GET";
  const token = cookies.get(env.cookieName);
  const body = props.body;
  const header = {
    "Content-Type": "application/json",
    "x-access-token": token && token.token,
    userid: token && token.userId,
  };

  const options = {
    method,
    headers: header,
    ...(method !== "GET" && { body: JSON.stringify(body) }),
  };

  const showError = (jsx) => {
    if (!errorElement) return;
    if (!errorRoot) {
      errorRoot = ReactDOM.createRoot(errorElement);
    }
    errorRoot.render(jsx);
    setTimeout(() => {
      if (errorRoot) errorRoot.render(null);
    }, 3000);
  };

  const res = await fetch(env.siteApi + props.url, options)
    .then((res) => res.json())
    .then(
      (result) => {
        if (result.error) {
          showError(
            <ShowError
              text={
                result.error
                  ? result.error
                  : result.message
                  ? result.message
                  : result.error.message
              }
              color={"red"}
            />
          );
        } else {
          if (result.message) {
            showError(<ShowError text={result.message} color={result.color} />);
          }
          return result;
        }
      },
      (err) => {
        if (err.status == "404") {
          showError(<ShowError text={"404"} color={err.color} />);
        }
        if (err.status == "400") {
          showError(
            <ShowError
              text={err.error ? err.error : err.message}
              color={err.color}
            />
          );
          console.log("400");
        } else {
          showError(
            <ShowError
              text={err.error ? err.error : err.message}
              color={err.color}
            />
          );
        }
      }
    );
  return res;
};

export default PostReq;
// const SearchCustomer = async () => {
//     if (!search || search.length < 3) return;
//     const result = await PostReq({
//       method: "Post",
//       url: "/panel/faktor/find-products",
//       body: { search: search },
//     });
//     setData("");
//     setTimeout(() => setData(result), 200);
//   };
